import React from 'react';
import cn from 'classnames';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { getText } from '../../../utils/ui/getText';
import Icon from '../../Icon';
import Button from '../../Button';
import styles from './index.styl';

const TextMessage = ({
  intl: { formatMessage },
  message,
  title,
  icon,
  onClick,
  buttonTitle,
  iconClassName = "mb4",
  buttonClassName
}) => {
  return (
    <div styleName="root">
      <If condition={icon}>
        <div  className={cn("tc dib", iconClassName)}>
          <Icon name={icon} size={48} />
        </div>
      </If>
      <If condition={title}>
        <p styleName="title">{getText(title, formatMessage)}</p>
      </If>
      <span styleName="message">{getText(message, formatMessage)}</span>
      <If condition={buttonTitle}>
        <Button onClick={onClick} color="primary" styleName="button" raised className={buttonClassName}>
          {getText(buttonTitle, formatMessage)}
        </Button>
      </If>
    </div>
  );
};

TextMessage.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  message: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  icon: PropTypes.string,
  onClick: PropTypes.func,
  iconClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  buttonTitle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default injectIntl(
  CSSModules(TextMessage, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Ui/TextMessage/index.jsx